const initialState = {
  bookings: null,
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_BOOKINGS":
      return {
        ...state,
        bookings: action.data,
      };
    case "ADD_BOOKING":
    case "DELETE_BOOKING_BY_ADMIN":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default bookingReducer;
